// extracted by mini-css-extract-plugin
export default {"bodyTopMargin":"YA+QN6qfkayjbhT0BShGzA==","bodyNoMargin":"xo2AVajn0XUdfeOkGwT1jw=="};